module.exports = __webpack_public_path__ + "media/images/views/candidate/request/wh-check-0543ca254eb9e2526fbdb334f41cb05b.png";